export enum PasswordStrengthLabel {
  VERY_WEAK = 'VERY WEAK',
  WEAK = 'WEAK',
  GOOD = 'GOOD',
  STRONG = 'STRONG',
}
